import { Injector } from '@angular/core';
import {
	Observable,
	Subject
}                   from 'rxjs';

export class AppInjector {

	private static injector: Injector;
	private static injector$: Subject<Injector> = new Subject<Injector>();

	static setInjector( injector: Injector ) {
		AppInjector.injector = injector;
		AppInjector.injector$.next( AppInjector.injector );
	}

	static getInjector(): Injector {
		return AppInjector.injector;
	}

	static getInjector$(): Observable<Injector> {
		return AppInjector.injector$;
	}
}
